import { Grid, Paper } from '@mui/material';
import { Outlet, useParams } from 'react-router-dom';

import { DetailsTabs } from './details-tabs';
import { SiTrackPage } from '../../../components/si-track-page';
import { WidgetsContainer } from './widgets-container.component';
import { useLoadData } from '../../../hooks/useLoadData';
import { ApiResponse } from '../../../models/api-response';
import { customersApiKeyStore } from '../../../api/customers-api-key-store';
import { Customer } from '../../../models/customer';
import { useNavigate } from 'react-router-dom';
import { UserPermissionName } from '../../../models/user-permission-name';
import { useAuthorize } from '../../../hooks/use-authorize';

export const CustomerDetailsPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { data, isLoading } = useLoadData<ApiResponse<Customer>>(customersApiKeyStore.getCustomer(id));

  const handleEditCustomer = (value: Customer) => {
    navigate(`/customers/edit/${id}`);
  };

  const permissionForTab = {
    officeTab: useAuthorize([UserPermissionName.VIEW_OFFICE]),
    projectTab: useAuthorize([UserPermissionName.VIEW_PROJECT]),
    unitTab: useAuthorize([UserPermissionName.VIEW_UNIT]),
    contactTab: useAuthorize([UserPermissionName.VIEW_CONTACT]),
    serviceTab: useAuthorize([UserPermissionName.VIEW_SERVICE_CUSTOMER]),
    fileTab: useAuthorize([UserPermissionName.VIEW_FILES]),
    contractTab: useAuthorize([UserPermissionName?.VIEW_CONTRACT_CUSTOMER]),
  };

  return (
    <SiTrackPage
      title={data?.data?.customerName ?? ''}
      onEdit={handleEditCustomer}
      isLoading={isLoading}
      actionPermissions={{ edit: UserPermissionName.EDIT_CUSTOMER }}
    >
      <WidgetsContainer customerID={id} />
      {!permissionForTab?.officeTab &&
      !permissionForTab?.projectTab &&
      !permissionForTab?.unitTab &&
      !permissionForTab?.contactTab &&
      !permissionForTab?.serviceTab &&
      !permissionForTab?.fileTab &&
      !permissionForTab?.contractTab ? null : (
        <Grid container justifyContent="space-between" spacing={3} style={{ paddingBottom: '10px' }}>
          <Grid item lg={12} sm={12} xl={12} xs={12}>
            <DetailsTabs contracts={data?.data?.customerContracts} permissionForTab={permissionForTab} />
          </Grid>
        </Grid>
      )}
      <Outlet />
    </SiTrackPage>
  );
};
